import { render, staticRenderFns } from "./o-keyboard.vue?vue&type=template&id=4f55c8a2&scoped=true&"
import script from "./o-keyboard.js?vue&type=script&lang=js&"
export * from "./o-keyboard.js?vue&type=script&lang=js&"
import style0 from "./o-keyboard.scss?vue&type=style&index=0&id=4f55c8a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f55c8a2",
  null
  
)

export default component.exports